// import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query"
// import { useQuery, useQueryClient } from "@tanstack/react-query"

import { getNotificaciones } from "../services/notificaciones.service";

export const useNotificaciones = () => {

    // const queryClient = useQueryClient();

    // const previousNotificationIdsRef = useRef(null);

    const notificacionesQuery = useQuery({
        queryKey: ['notificaciones'],
        queryFn: () => getNotificaciones(),
        staleTime: 30_000, // 30 segundos
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchInterval: 60_000, // 60 segundos  
        refetchIntervalInBackground: true,
        placeholderData: {
            data: {}
        }
    });

    // useEffect(() => {
      
    //     if (!notificacionesQuery.data) return;

    //     const { data } = notificacionesQuery.data;

    //     if (!data || Object.values(data).length === 0) return;

    //     const notificaciones = Object.values(data).flat();

    //     const notificationIds = new Set(notificaciones.map(noti => noti._id));

    //     // Primer fetch: solamente guardar los IDs existentes
    //     if (previousNotificationIdsRef.current === null) {

    //         previousNotificationIdsRef.current = notificationIds;

    //         return;

    //     }

    //     // Obtener únicamente notificaciones nuevas
    //     const nuevasNotificaciones = notificaciones.filter(noti => !previousNotificationIdsRef.current.has(noti._id));

    //     // Actualizar referencia
    //     previousNotificationIdsRef.current = notificationIds;

    //     if (nuevasNotificaciones.length === 0) return;

    //     const categories = new Set(nuevasNotificaciones.map(noti => noti.category));

    //     if (categories.has('CITA')) {

    //         queryClient.invalidateQueries({
    //             queryKey: ['agenda']
    //         });

    //     }

    //     if (categories.has('INMUNOTERAPIA')) {

    //         queryClient.invalidateQueries({
    //             queryKey: ['agendaInmunoterapia']
    //         });

    //     }

    //     if (categories.has('APP')) {

    //         queryClient.invalidateQueries({
    //             queryKey: ['resumenPaciente']
    //         });

    //     }

    // }, [notificacionesQuery.data, queryClient]);

    return {
        notificacionesQuery,
    }
    
}